<template>
  <div class="container-fluid sortableList">
    <div class="row padding-left-15px">
     <div class="row margin-Top-2Perc margin-bottom-2Perc">
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 font-size-18px margin-top-3px margin-bottom-15px padding-right-0Px text-align-center">
          Search
        </div>
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 padding-right-0Px">
          <div class="form-group width-90Perc margin-Top-0Point9Perc">
            <div class="icon-addon addon-lg">
              <input type="text" class="form-control background-gray border-rounded" v-model="searchQuery" autocomplete="off"/>
              <label class="glyphicon glyphicon-search"></label>
            </div>
          </div>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 text-align-left padding-left-2Pont4Perc">
          <!-- <div class="checkbox margin-top-5px">
            <label><input type="checkbox" value="">Include Unenrolled Users</label>
          </div> -->
        </div> 
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"></div>    
      </div> 
    </div>
    <sortable-table-for-user-progress v-if="getCurrentSelectedSubOption === 0" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-user-progress>
    <sortable-table-for-discussion v-if="getCurrentSelectedSubOption === 1" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-discussion>
    <sortable-table-for-challenges v-if="getCurrentSelectedSubOption === 5" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-challenges>
    <sortable-table-for-challenge-with-release-and-challenge-title v-if="getCurrentSelectedSubOption === 2" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns" :colspanArr="colSpanArr"></sortable-table-for-challenge-with-release-and-challenge-title>
    <sortable-table-for-challenge-with-challenge-title v-if="getCurrentSelectedSubOption === 3" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-challenge-with-challenge-title>
    <sortable-table-for-mcq v-if="getCurrentSelectedSubOption === 6" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-mcq>
    <sortable-table-for-deep-dive v-if="getCurrentSelectedSubOption === 7" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-deep-dive>
    <sortable-table-for-lesson-wise-progress-report v-if="getCurrentSelectedSubOption === 9" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-lesson-wise-progress-report>
    <sortable-table-for-adaptive-game v-if="getCurrentSelectedSubOption === 10" :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-adaptive-game>
  </div>
</template>

<script>
import SortableTableForUserProgress from '@/components/SortableGridForUserProgress'
import SortableTableForDiscussion from '@/components/SortableGridForDiscussion'
import SortableTableForDeepDive from '@/components/SortableGridForDeepDive'
import SortableTableForAdaptiveGame from '@/components/SortableGridForAdaptiveGame'
import SortableTableForChallenges from '@/components/SortableGridForChallenges'
import SortableTableForChallengeWithChallengeTitle from '@/components/SortableGridForChallengeWithChallengeTitle'
import SortableTableForLessonWiseProgressReport from '@/components/SortableGridForLessonWiseProgressReport'
import SortableTableForChallengeWithReleaseAndChallengeTitle from '@/components/SortableGridForChallengeWithReleaseAndChallengeTitle'
import SortableTableForMCQ from '@/components/SortableGridForMCQ'
export default {
  props: ['responseObj', 'sortableColumnName', 'columnNameToShow', 'linkColumnName', 'selectedsubOption', 'colspanArr'],
  created: function () {
    this.setDefaultValues()
  },
  data () {
    return {
      searchQuery: '',
      sortColumns: [],
      columnName: [],
      linkColumns: [],
      respObj: [],
      colSpanArr: []
    }
  },
  components: {
    'sortable-table-for-user-progress': SortableTableForUserProgress,
    'sortable-table-for-discussion': SortableTableForDiscussion,
    'sortable-table-for-deep-dive': SortableTableForDeepDive,
    'sortable-table-for-adaptive-game': SortableTableForAdaptiveGame,
    'sortable-table-for-challenges': SortableTableForChallenges,
    'sortable-table-for-challenge-with-challenge-title': SortableTableForChallengeWithChallengeTitle,
    'sortable-table-for-challenge-with-release-and-challenge-title': SortableTableForChallengeWithReleaseAndChallengeTitle,
    'sortable-table-for-mcq': SortableTableForMCQ,
    'sortable-table-for-lesson-wise-progress-report': SortableTableForLessonWiseProgressReport
  },
  name: 'sortableList',
  computed: {
    getCurrentSelectedSubOption: {
      get: function () {
        return parseInt(this.selectedsubOption)
      }
    }
  },
  methods: {
    setDefaultValues: function () {
      // console.log(' COL SPAN ARR ' + JSON.stringify(this.colspanArr))
      this.respObj = this.responseObj
      this.sortColumns = this.sortableColumnName
      this.columnName = this.columnNameToShow
      this.linkColumns = this.linkColumnName
      this.colSpanArr = this.colspanArr
    }
  },
  watch: {
    responseObj: function (newVal, oldVal) {
      this.setDefaultValues()
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    }
  }
}
</script>
<style scoped>
.padding-left-15px {
  padding-left: 15px !important;
}
.background-gray {
  background-color: #ddd;
}
.margin-Top-0Point9Perc{
  /* margin-top: 0.9%; */
}
.width-90Perc {
  width: 90%;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.font-size-18px{
    font-size: 18px !important;
}
.vertical-align {
  /* display: flex;
  align-items: center; */
}
.margin-top-3px{
  margin-top:3px !important;
}
.margin-bottom-2Perc{
  margin-bottom:2% !important;
}
.margin-bottom-15px{
  margin-bottom:15px !important;
}
.text-align-right{
 text-align: right;
}
.text-align-left{
 text-align: left;
}
.text-align-center{
 text-align: center;
}
.margin-top-5px{
  margin-top:5px;
}
.padding-left-2Pont4Perc{
  padding-left: 2.4%;
}
</style>





// WEBPACK FOOTER //
// src/pages/SortableList.vue